import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/crossEye.svg';

export const IconCrossEye = createIconComponent(Icon);
